import { graphql } from "@/graphql/codegen"

graphql(`
  query GetSalesProductList($input: ProductListInput!) {
    product {
      list(input: $input) {
        ... on ProductListSuccess {
          products {
            productId
            publicId
            vendorDescription
            companyProductDescription
            stockType
            company {
              name
            }
            classification {
              classificationId
              productManager {
                userId
                firstName
                lastName
                email
              }
            }
            locationsAssociations {
              locationAssociationId
              shipping {
                ...LocationBaseFields
              }
            }
            packageUsWeight
            packageUsWeightUomDetails {
              name
            }
            packageMetricWeight
            packageMetricWeightUomDetails {
              name
            }
            packagesPerPallet
            palletUsWeight
            palletUsWeightUomDetails {
              name
            }
            palletMetricWeight
            palletMetricWeightUomDetails {
              name
            }
          }
        }
        ... on ProductListFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
